



















































import Vue from "vue";
import { mapActions } from "vuex";
import { MODULE_STORE_ADMIN, REMOVE_CATEGORY, UPDATE_CATEGORY } from "../../../store/admin/types";

export default Vue.extend({
  props: {
    category: {
      type: Object,
      required: true
    }
  },
  computed: {
    hadChangingName(): boolean {
      return this.oldNameRu !== this.nameRu
        || this.oldNameEn !== this.nameEn
    }
  },
  data() {
    return {
      editNameEn: false,
      editNameRu: false,
      preloaderSaving: false,
      nameRu: "",
      nameEn: "",
      oldNameRu: "",
      oldNameEn: "",
    };
  },
  mounted() {
    this.nameRu = this.category.name.ru;
    this.nameEn = this.category.name.en;
    this.oldNameRu = this.category.name.ru;
    this.oldNameEn = this.category.name.en;
  },
  methods: {
    ...mapActions(
      MODULE_STORE_ADMIN,
      [UPDATE_CATEGORY, REMOVE_CATEGORY]
    ),
    update() {
      this.preloaderSaving = true;
      const name = this.getUpdatedName();
      const updatedCategory = Object.assign(this.category, { name });
      this.updateCategory(updatedCategory);
      this.updateOldName();
      this.preloaderSaving = false;
    },
    getUpdatedName() {
      return {
        ru: this.nameRu,
        en: this.nameEn
      };
    },
    updateOldName() {
      this.oldNameRu = this.nameRu;
      this.oldNameEn = this.nameEn;
    },
    remove() {
      if (confirm(`Вы действительно хотите удалить роль "${this.nameRu}"?`)) {
        this[REMOVE_CATEGORY](this.category);
      }
    }
  }
});
